import { query } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';
import Timeline from '../../../../../components/Timeline';
import { colors } from '../../../../../lib/colors';
import CheckData from '../../../../../components/CatchError';
import numeral from 'numeral';

class BlockVisibility extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);
        this.buildRankingsFields = this.buildRankingsFields.bind(this);
        this.customYLabelType = this.customYLabelType.bind(this);

        this.state = {
            data: [],
            loading: true,
        };
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            if (!this.props.prompt_uids?.length) return;
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                own_domain: this.props.project?.own_domain,
                competitiors: this.props.project?.competitors,
                platforms: this.props.platforms,
            });
            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));
            this.setState({
                data,
                loading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }
    componentDidMount() {
        this.getData({});
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.brand?.toLowerCase().includes(search.toLowerCase()));
    }

    buildRankingsFields(obj) {
        return Object.keys(obj)
            .filter((key) => key.endsWith('Rankings') && key !== 'ownDomainRankings')
            .map((key) => {
                const match = key.match(/comp(\d+)(Rankings)/);

                return {
                    key,
                    label:
                        this.props.project?.competitors?.[match[1] - 1]?.domain ||
                        `comp ${match[1]}`,
                };
            });
    }

    customYLabelType(value) {
        return `${numeral(value).format('0 a')}%`;
    }

    render() {
        const { t } = this.props;

        const competitiorsKeys = this.state.data?.length
            ? this.buildRankingsFields(this.state.data[0])
            : [];
        const keys = () => [
            {
                label:
                    this.props.project?.own_domain ||
                    t('ai_tracking.keyword_detail.visibility.own_domain'),
                key: 'ownDomainRankings',
            },
            ...competitiorsKeys,
        ];

        const singleData = this.state.data?.length === 1;

        const chartData = (datasetIndex) => ({
            labels: this.state.data?.map((item) => item?.dt?.value),
            datasets: keys(t).map((item, i) => ({
                label: item?.label,
                type: item.type ?? 'line',
                data: this.state.data?.map((data) => (data[item.key] / data.urls) * 100),
                backgroundColor: [colors[i], colors[i]],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: 'y',
                hidden: item.hidden ?? false,
                borderRadius: 4,
                tension: 0.4,
                pointRadius: singleData ? 6 : 0,
                pointHoverRadius: singleData ? 8 : 6,
            })),
        });
        return (
            <div className="card rounded-main ">
                <div className="card-body">
                    <CheckData data={this.state.data} loading={this.state.loading}>
                        <Timeline
                            chartSize="lg"
                            dontShowMetrics
                            metricType="primary"
                            data={this.state.data}
                            chartData={chartData}
                            forceRun={this.forceRun}
                            xAxisTitle={t('ai_tracking.keyword_detail.visibility.date')}
                            header={t('ai_tracking.keyword_detail.visibility.visibility_overtime')}
                            keys={keys(t)}
                            showLabelAsPercentage={true}
                            customYLabelType={this.customYLabelType}
                            customLegends
                            customChartSize={400}
                            customEmptyMessage={t('global.no_data')}
                        />
                    </CheckData>
                </div>
            </div>
        );
    }
}

export default withTranslation()(BlockVisibility);
